<script setup lang="ts">
import type { CustomOptionGroup } from "../api/products";
defineProps<{ group: CustomOptionGroup; disabled?: boolean; editableName?: boolean }>();
const emit = defineEmits<{ dragStart: [event: DragEvent]; dragEnd: []; dropRow: []; rename: [name: string] }>();
</script>

<template>
  <article
    class="parameter-row"
    :class="{ inactive: !group.isActive }"
    @dragover.prevent
    @drop.prevent.stop="emit('dropRow')"
  >
    <header class="parameter-label">
      <input
        v-if="editableName && !group.name"
        class="parameter-name-input"
        aria-label="新大类名称"
        placeholder="大类名称"
        maxlength="100"
        :disabled="disabled"
        @change="emit('rename', ($event.target as HTMLInputElement).value)"
        @keydown.enter.prevent="emit('rename', ($event.target as HTMLInputElement).value)"
      >
      <button
        v-else
        class="parameter-name-block"
        type="button"
        :draggable="!disabled"
        :disabled="disabled"
        :aria-label="`拖动${group.name}参数组`"
        :aria-description="group.required ? '此参数需填写' : undefined"
        title="拖动调整参数组顺序"
        @dragstart.stop="emit('dragStart', $event)"
        @dragend="emit('dragEnd')"
      >
        <span>{{ group.name }}</span><span
          v-if="group.required"
          class="required-star"
          aria-hidden="true"
        >*</span>
      </button>
      <slot name="actions" />
    </header>
    <slot />
  </article>
</template>

<style scoped>
.parameter-row { display:grid; grid-template-columns:112px minmax(0,1fr); gap:10px; border-top:1px solid var(--line,#e5e5e5); padding:8px 0; }
.parameter-row:has(.image-card-grid) { padding:16px 0; align-items:center; }
.parameter-row:has(.image-card-grid) .parameter-label { align-self:center; }
.parameter-label { position:relative; width:112px; height:36px; align-self:center; }
.parameter-name-block { box-sizing:border-box; display:flex; align-items:center; justify-content:center; gap:3px; width:112px; height:36px; min-height:36px; border:0; border-radius:4px; padding:6px 8px; background:#f5f5f5; color:#333; font:400 14px/1.5 system-ui,"Microsoft YaHei",sans-serif; cursor:grab; user-select:none; white-space:nowrap; overflow:hidden; }
.parameter-name-block>span:first-child { min-width:0; overflow:hidden; text-overflow:ellipsis; }
.parameter-name-input { box-sizing:border-box; width:112px; height:36px; padding:6px 8px; border:1px dashed #999; border-radius:4px; background:#f5f5f5; color:#333; font:400 14px/1.5 system-ui,"Microsoft YaHei",sans-serif; text-align:center; }
.parameter-name-input::placeholder { color:#666; }
.parameter-label:has(.library-row-tools):hover .parameter-name-block,.parameter-label:has(.library-row-tools):focus-within .parameter-name-block { padding-left:4px; padding-right:42px; }
@media(hover:none) { .parameter-label:has(.library-row-tools) .parameter-name-block { padding-left:4px; padding-right:42px; } }
.parameter-name-block:hover:not(:disabled) { background:#f5f5f5; }
.parameter-name-block:active { cursor:grabbing; }
.parameter-name-block:disabled { cursor:not-allowed; color:#666; }
.parameter-name-block:focus-visible { outline:2px solid #000; outline-offset:3px; }
.required-star { color:#d32f2f; font-size:12px; font-weight:400; line-height:1; align-self:center; }
.inactive { background:#f5f5f5; }
@media(max-width:640px) { .parameter-row { gap:8px; } }
</style>
